import { endpoints } from "../resources/resources";
import { api, setAuthorizationToken } from "./api";

export class AuthService {
  static async Login(payload) {
    const { data } = await api.post(endpoints.auth.login, payload);
    setAuthorizationToken(data?.data?.accessToken);
    localStorage.setItem("token", data?.data?.accessToken);
    return data;
  }

  static async SignUp(payload) {
    const { data } = await api.post(endpoints.auth.signup, payload);
    return data;
  }

  static async ProviderSignup(payload) {
    const { data } = await api.post(endpoints.auth.providerSignup, payload);
    return data;
  }
}
